angular.module('gym.invoices').controller('BulkMarkAsPaidCtrl', ["$scope", "$rootScope", "$modalInstance", "selectedInvoices", "type", "bulkStatusChange", function($scope, $rootScope, $modalInstance, selectedInvoices, type, bulkStatusChange) {
  var gym, typeLabelMap;
  gym = $rootScope.gym;
  $scope.currency = gym.currency;
  $scope.selectedInvoices = selectedInvoices;
  $scope.type = type;
  $scope.totalCreditApplied = selectedInvoices.reduce(function(acc, item) {
    if (item.credit_applied_amount) {
      return +(+acc + +item.credit_applied_amount).toFixed(2);
    } else {
      return acc;
    }
  }, 0);
  $scope.params = {
    approval_date: gym.today
  };
  $scope.options = [['pay_with_cash', 'Cash'], ['pay_with_pos', 'POS'], ['pay_with_other', 'Other method']];
  typeLabelMap = {
    pay_with_cash: 'cash',
    pay_with_pos: 'POS',
    pay_with_other: 'other method'
  };
  $scope.secondaryTypeLabelMap = {
    pay_with_cash: 'Cash',
    pay_with_pos: 'POS',
    pay_with_other: 'Other'
  };
  $scope.submit = function() {
    var params;
    params = {
      approval_date: $scope.params.approval_date,
      property: $scope.type,
      label: typeLabelMap[$scope.type],
      onSuccess: function() {
        return $modalInstance.close();
      },
      onError: function() {
        return $scope.isLoading = false;
      },
      onLoading: function() {
        return $scope.isLoading = true;
      }
    };
    return bulkStatusChange(params);
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
